import { useCallback } from 'react';
import { Flex, Box, Button, useToast } from '@chakra-ui/react';
import { useIntl } from 'react-intl';

const toastStatuses = {
    success: { bg: 'green.100', borderColor: 'green.500' },
    error: { bg: 'red.200', borderColor: 'red.900' },
    info: { bg: 'blue.100', borderColor: 'blue.500' },
};

const useCommonToast = () => {
    const intl = useIntl();
    const continueLabel = intl.formatMessage({ id: 'common_continue' });

    const toast = useToast({
        defaultOptions: {
            position: 'top',
        },
    });

    const wrapper = useCallback(
        (params) => {
            if (typeof params === 'string') {
                toast({
                    render: ({ onClose }) => (
                        <ToastWrapper status={'success'}>
                            <Box mr={6}>{params}</Box>

                            <ContinueButton onClick={onClose}>{continueLabel}</ContinueButton>
                        </ToastWrapper>
                    ),
                });
            } else {
                const { status = 'success', message, slot, ...options } = params;

                if (!toast.isActive(options.id)) {
                    toast({
                        render: ({ onClose }) => (
                            <ToastWrapper status={status}>
                                <Box mr={6}>{message}</Box>

                                <ContinueButton onClick={onClose}>{continueLabel}</ContinueButton>

                                {slot}
                            </ToastWrapper>
                        ),
                        ...options,
                    });
                }
            }
        },
        [continueLabel, toast]
    );

    return wrapper;
};

const ToastWrapper = ({ status, ...props }) => {
    return (
        <Flex
            wrap="wrap"
            align="center"
            px={6}
            py={4}
            color="gray.800"
            borderWidth="1px"
            borderRadius="md"
            status={status}
            bg={toastStatuses[status].bg}
            borderColor={toastStatuses[status].borderColor}
            {...props}
        />
    );
};

const ContinueButton = (props) => {
    return <Button textTransform="capitalize" ml="auto" variant="secondary" bg="white" {...props} />;
};

export default useCommonToast;
